import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { SiteModel } from '../models/site.model';
import { SbApiService } from '../services/sb-api.service';

@Component({
  selector: 'app-sb-client',
  templateUrl: './sb-client.component.html',
  styleUrls: ['./sb-client.component.scss']
})
export class SbClientComponent implements OnInit {
  clientSites: SiteModel[];
  testData: any;

  constructor(
    private siteService: SbApiService,
    private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    // this.siteService.getSitesByClient().subscribe({
    //   next: response => {
    //     this.clientSites = response.data;
    //     console.log('Client Sites: ', this.clientSites);
    //   },
    //   error: error => console.error(error)
    // });
  }

  ngDoCheck() {
    // Se utiliza ngDoCheck para que al hacer una petición detecte los cambios y inicialicen las dos variables
    this.clientSites = this.activatedRoute.snapshot.data.clientSites.data;
    // console.log('Client Sites List: ', this.clientSites);
  }

  public sanitizeUrl(url) {
    return url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public iframeText(site) {
    // console.log(this.sanitizeUrl(site.url));
    // console.log(site.title);
    return `<iframe src="${site.url}" title="${site.title}" frameborder="0"></iframe>`;
  }

}
